module.exports = __webpack_public_path__ + "static/img/ss02.04bef3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/rickle/ss02.png
// module id = 0C1L
// module chunks = 0